module.exports = __webpack_public_path__ + "assets/img/section-4-landing-page-cubcakes.7866c046.png";